<h3 class="title-divider">
  {{ "ErgebnisoptionenStammperson" | translate }}
</h3>
<fieldset [disabled]="disabled">
  <div class="form-check mt-1">
    <input
      (ngModelChange)="model && (model.personstammVollstaendig = $event)"
      [ngModel]="model && model.personstammVollstaendig"
      [value]="true"
      class="form-check-input"
      id="personstammVollstaendig"
      name="personstammVollstaendig"
      type="radio" />
    <label class="form-check-label" for="personstammVollstaendig">
      {{ "PersonstammVollstaendig" | translate }}
    </label>

    <div class="ms-4">
      <cap-form-control labelKey="MitAdresse">
        <input
          (ngModelChange)="model && (model.personAdresse = $event)"
          [disabled]="model && !model.personstammVollstaendig"
          [ngModel]="model && model.personAdresse"
          name="mitAdresse"
          type="checkbox" />
      </cap-form-control>
      <cap-form-control labelKey="MitAciIroleNr">
        <input
          (ngModelChange)="model && (model.aciIroleNr = $event)"
          [disabled]="model && !model.personstammVollstaendig"
          [ngModel]="model && model.aciIroleNr"
          name="aciiroleNr"
          type="checkbox" />
      </cap-form-control>
    </div>
  </div>
  <div class="form-check mt-2">
    <input
      (change)="disableSubChoices()"
      (ngModelChange)="model && (model.personstammVollstaendig = $event)"
      [ngModel]="model && model.personstammVollstaendig"
      [value]="false"
      class="form-check-input"
      id="nurZentraleId"
      name="nurZentraleId"
      type="radio" />
    <label class="form-check-label" for="nurZentraleId">
      {{ "NurZentraleId" | translate }}
    </label>
  </div>
</fieldset>
